module.exports = __webpack_public_path__ + "img/blog11.89c7a211.jpg";